import script from "./FormNewPaymentComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormNewPaymentComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormNewPaymentComponent.vue?vue&type=style&index=0&id=4cd1f258&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cd1f258"]])

export default __exports__